import { axiosInstance } from "./config";

export default {
  state: {
    benefits_zones: {},
  },
  mutations: {
    SetBenefits_zones(state, payload) {
      state.benefits_zones = payload;
    },
    Set_update_Benefits_zones(state, payload) {
      let zone = state.benefits_zones.find((g) => g.id == payload.id)
      zone.image = payload.image;
      zone.name_en = payload.name_en;
      zone.name_it = payload.name_it;
      zone.name_ru = payload.name_ru;
    },
  },
  actions: {
    async Get_Benefits({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/benefits_zones${payload}`)
        .then(function (data) {
          commit("SetBenefits_zones", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_Benefits(commit, payload) {
      return await axiosInstance
        .post("/benefits_zones", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_Benefits({ commit }, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/benefits_zones/" + payload.id, formData, config)
        .then(function (data) {
          commit("Set_update_Benefits_zones", data?.data?.data);
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_Benefits(commit, payload) {
      return await axiosInstance
        .delete("/benefits_zones/" + payload.id)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_benefits_zones: (state) => state.benefits_zones,
  },
};
